import { type LessonFilters, type ScopedLessonRoleName } from './AdminLessonPermissionsTab.types';

// updatedAt is required by users_controller#raise_if_old_version, which 406s without it.
export const USER_LESSON_PERMISSIONS_FIELDS = ['id', 'email', 'updatedAt', 'roles'];

export const LESSON_FIELDS = ['id', 'title', 'tag', 'locale', 'author'];

export const SCOPED_LESSON_ROLE_NAMES = ['lesson_editor', 'reviewer', 'previewer'] as const;

// The four radio columns. A null role means Hidden: the lesson has no scoped role.
export const ROLE_COLUMNS: {
    role: ScopedLessonRoleName | null;
    column: ScopedLessonRoleName | 'hidden';
    label: string;
}[] = [
    { role: 'lesson_editor', column: 'lesson_editor', label: 'Edit' },
    { role: 'reviewer', column: 'reviewer', label: 'Review' },
    { role: 'previewer', column: 'previewer', label: 'Preview' },
    { role: null, column: 'hidden', label: 'Hidden' },
];

export const EMPTY_FILTERS: LessonFilters = { locale: '', tag: '', title: '' };

export const INITIAL_ROWS_TO_SHOW = 50;
export const ROWS_TO_ADD_ON_SCROLL = 25;
